import { postQueue } from 'actions'

export const createQueue = async (payload) => {
  const res = await postQueue(payload)
  return {
    type: 'POST_QUEUE_SUCCESS',
    data: res
  }
}
